import svgUrl from "ni:svgr;zRah0ULiCGgGt5juPZRfW1HGBtDh_1DIgIV3-08Egcg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const EnrichmentFirecrawlLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><g filter="var(--tbl--ui-node-icon--enrichment--firecrawl-l)"><text fill="currentColor" textAnchor="middle" x="50%" y="50%" dy=".5em" fontSize="28px">{"\uD83D\uDD25"}</text></g><defs><filter id="tbl--ui-node-icon--enrichment--firecrawl-l--disabled"><feColorMatrix type="saturate" values={0.01} /></filter></defs></svg>;
const Memo = memo(EnrichmentFirecrawlLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "EnrichmentFirecrawlLIcon";
}